import { CheckboxGroup } from "../../core/components/CheckboxGroup";
import { IconCheckbox } from "../../core/components/IconCheckbox";
import { ProductIcon } from "../../core/components/ProductIcon";
import { SelectAllButton } from "../../core/components/SelectAllButton";
import { Field, useField } from 'formik';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommunicationProductsField = _ref => {
  let {
    name,
    products
  } = _ref;
  const [{
    value
  }, {
    error,
    touched
  }, {
    setValue
  }] = useField(name);
  return /*#__PURE__*/_jsx(CheckboxGroup, {
    error: touched && error,
    label: "Products",
    toolbar: /*#__PURE__*/_jsx(SelectAllButton, {
      areAllSelected: value.length === products.length,
      onDeselectAllClick: () => setValue([]),
      onSelectAllClick: () => setValue(products.map(product => product.id))
    }),
    "data-sentry-element": "CheckboxGroup",
    "data-sentry-component": "CommunicationProductsField",
    "data-sentry-source-file": "CommunicationProductsField.tsx",
    children: products.map(product => /*#__PURE__*/_jsx(Field, {
      as: IconCheckbox,
      checked: value.includes(product.id),
      icon: /*#__PURE__*/_jsx(ProductIcon, {
        height: "24",
        productId: product.id,
        width: "24"
      }),
      label: product.displayName,
      name: "products",
      value: product.id
    }, product.id))
  });
};